import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../QuizHub/QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import hh from "../../images/hub-img.webp";
import cc from "../../images/hub-card.webp";
import gg from "../../images/gift-green.svg";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import { END_URL, IMG_URL } from "../../config";
import { slugify } from "../../utils/slugify";
import arr from "../../images/downarr.svg";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { saveCurrentPage } from "../../utils/breadcrumb";
import ll from "../../images/yellow-loc.svg";

import l4 from "../../images/strength.svg";
import l1 from "../../images/take-ic.svg";
import l3 from "../../images/explor.svg";
import l2 from "../../images/discov-ic.svg";

import l5 from "../../images/Creative.svg";
import l6 from "../../images/Helping.svg";
import l7 from "../../images/Leadership.svg";
import l8 from "../../images/Analytical.svg";

import l9 from "../../images/Creative.svg";
import l10 from "../../images/Helping.svg";
import l11 from "../../images/Leadership.svg";
import l12 from "../../images/Analytical.svg";

import l13 from "../../images/Independent.svg";
import l14 from "../../images/Structured.svg";

import lb from "../../images/professionals.png";
import pk from "../../images/couples.png";
import yl from "../../images/entrepuner.png";


// professionals  

function SeoTemplate({ slug, token, onsignup, onLoginChange, userdetail }) {
  const [SeoTemplate, setSeoTemplate] = useState(null);

  const [blog, setblog] = useState([]);

  const [archetype, setarchetype] = useState([]);

  const [faqData, setfaqData] = useState([]);

  const [loading, setLoading] = useState(true);

  const [openIndex, setOpenIndex] = useState(0);

  const [CarrerModal, setCarrerModal] = useState(false);
  const [careerContent, setCareerContent] = useState("");

  useEffect(() => {
    fetchHub();
  }, [slug]);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fetchHub = async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${END_URL}/seo-temp-page/${slug}`);

      setSeoTemplate(response.data.seo_template);
      setfaqData(response.data.seo_faq);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loadingDiv">
        <img src={ff} alt="Loading..." />
      </div>
    );
  }

  const careerCards = [
    {
      image: SeoTemplate?.career_image_1,
      alt: SeoTemplate?.career_image_1_alt,
      content: SeoTemplate?.career_content_1,
    },
    {
      image: SeoTemplate?.career_image_2,
      alt: SeoTemplate?.career_image_2_alt,
      content: SeoTemplate?.career_content_2,
    },
    {
      image: SeoTemplate?.career_image_3,
      alt: SeoTemplate?.career_image_3_alt,
      content: SeoTemplate?.career_content_3,
    },
    {
      image: SeoTemplate?.career_image_4,
      alt: SeoTemplate?.career_image_4_alt,
      content: SeoTemplate?.career_content_4,
    },
    {
      image: SeoTemplate?.career_image_5,
      alt: SeoTemplate?.career_image_5_alt,
      content: SeoTemplate?.career_content_5,
    },
    {
      image: SeoTemplate?.career_image_6,
      alt: SeoTemplate?.career_image_6_alt,
      content: SeoTemplate?.career_content_6,
    },
  ].filter((card) => card.content);

  const discoverCards = [
    {
      image: SeoTemplate?.discover_image_1,
      alt: SeoTemplate?.discover_image_1_alt,
      content: SeoTemplate?.discover_content_1,
    },
    {
      image: SeoTemplate?.discover_image_2,
      alt: SeoTemplate?.discover_image_2_alt,
      content: SeoTemplate?.discover_content_2,
    },
    {
      image: SeoTemplate?.discover_image_3,
      alt: SeoTemplate?.discover_image_3_alt,
      content: SeoTemplate?.discover_content_3,
    },
    {
      image: SeoTemplate?.discover_image_4,
      alt: SeoTemplate?.discover_image_4_alt,
      content: SeoTemplate?.discover_content_4,
    },
    {
      image: SeoTemplate?.discover_image_5,
      alt: SeoTemplate?.discover_image_5_alt,
      content: SeoTemplate?.discover_content_5,
    },
    {
      image: SeoTemplate?.discover_image_6,
      alt: SeoTemplate?.discover_image_6_alt,
      content: SeoTemplate?.discover_content_6,
    },
  ].filter((card) => card.content);

  return (
    <>
      <div className={`hub-main final-template seo-template ${SeoTemplate?.seo_theme}`}>
        <div className="ques-main hub-cont-banner seo-banner-temp">
          <div className="container-fluid">
            <div className="row ques-row">
              <div className="col-12">
                <div
                  className="ques-top"
                  style={{
                    "--banner_image": `url(${IMG_URL}/d0/${SeoTemplate?.seo_banner})`,
                  }}
                >
                  <img
                    src={`${IMG_URL}/d0/${SeoTemplate?.seo_banner}`}
                    alt={SeoTemplate?.seo_banner_alt}
                    style={{ display: "none" }}
                  />

                  <div className="ques-top-title">
                    <div
                      className="quiz-banner-content"
                      dangerouslySetInnerHTML={{
                        __html: SeoTemplate?.seo_content,
                      }}
                    />

                    <div className="hub-banner-bnts">
                      {SeoTemplate?.seo_explore_btn &&
                        SeoTemplate?.seo_explore_link && (
                          <a
                            href={`/${SeoTemplate?.seo_explore_link}`}
                            class="new-commom-btn homearche-explore"
                            style={{
                              "--blur_button_color":SeoTemplate.seo_explore_btn_color,
                              "--topic_banner_btn_2_color":
                                SeoTemplate.seo_explore_btn_color,
                              "--topic_banner_btn_2_color_hover":
                                SeoTemplate.seo_explore_btn_color_hover,
                              "--luminus_button_color_15": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 15%, white)`,
                              "--luminus_button_color_25": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 25%, white)`,
                              "--luminus_button_color_38": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 38%, white)`,
                              "--luminus_button_color_45": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 45%, white)`,
                              "--luminus_button_color_50": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 50%, white)`,
                              "--luminus_button_color_55": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 55%, white)`,
                              "--luminus_button_color_70": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 70%, white)`,
                              "--luminus_button_color_85": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 85%, white)`,
                              "--luminus_button_color_92": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 92%, white)`,
                              "--luminus_button_color_100":
                                SeoTemplate.seo_explore_btn_color,
                            }}
                          >
                            <span>{SeoTemplate?.seo_explore_btn}</span>

                            <span class="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                          </a>
                        )}

                      {SeoTemplate?.seo_reveal_btn &&
                        SeoTemplate?.seo_reveal_link && (
                          <a
                            href={`/${SeoTemplate?.seo_reveal_link}`}
                            class="new-commom-btn hub-banner-reveal"
                            style={{
                              "--blur_button_color":SeoTemplate.seo_reveal_btn_color,
                              "--topic_banner_btn_2_color":
                                SeoTemplate.seo_reveal_btn_color,
                              "--topic_banner_btn_2_color_hover":
                                SeoTemplate.seo_reveal_btn_color_hover,
                              "--luminus_button_color_15": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 15%, white)`,
                              "--luminus_button_color_25": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 25%, white)`,
                              "--luminus_button_color_38": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 38%, white)`,
                              "--luminus_button_color_45": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 45%, white)`,
                              "--luminus_button_color_50": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 50%, white)`,
                              "--luminus_button_color_55": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 55%, white)`,
                              "--luminus_button_color_70": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 70%, white)`,
                              "--luminus_button_color_85": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 85%, white)`,
                              "--luminus_button_color_92": `color-mix(in srgb, ${SeoTemplate.seo_reveal_btn_color} 92%, white)`,
                              "--luminus_button_color_100":
                                SeoTemplate.seo_reveal_btn_color,
                            }}
                          >
                            <span>{SeoTemplate?.seo_reveal_btn}</span>

                            <span class="righ-arr">
                              <FontAwesomeIcon icon={faArrowRight} />
                            </span>
                          </a>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="hub-section">
          <div className="container">
            <div className="row hub-pattern-card-row  carrer-start">
              <div className="hub-pattern-card-title">
                <div
                  dangerouslySetInnerHTML={{
                    __html: SeoTemplate?.seo_career_title,
                  }}
                />
              </div>

              <div className="hub-pattern-card-outer hub-pattern-card-outer-poular best-role seo-row1">
                {careerCards?.map((card, index) => (
                  <div className="hub-pattern-cards" key={index}>
                    <div>
                      <img
                        src={`${IMG_URL}/d0/${card.image}`}
                        alt={card?.alt}
                      />
                    </div>

                    <div className="hub-pattern-cards-content">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: card.content || "",
                        }}
                      />

                      {card.buttonLink && card.buttonLabel && (
                        <a
                          className="new-commom-btn hub-banner-reveal"
                          onClick={(e) => {
                            e.preventDefault();
                            setCareerContent(card.buttonLink);
                            setCarrerModal(true);
                          }}
                        >
                          <span>{card.buttonLabel}</span>

                          <span className="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>

        <section className="seo-steps-cont">
          <div className="container">
            <div className="row hub-pattern-popular seo-steps">
              <div className="hub-pattern-card-title">
                <div className="aeche-type-title">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: SeoTemplate?.common_role_title,
                    }}
                  />
                </div>
              </div>

              <div className="hub-pattern-card-outer">

                 {[1, 2, 3, 4,5].map((num) => {
                      const icon = SeoTemplate?.[`common_role_icon_${num}`];
                      const iconAlt = SeoTemplate?.[`common_role_icon_${num}_alt`];
                      const content = SeoTemplate?.[`common_role_conetent_${num}`];

                        if (!icon || !content) return null;
                        
                        return (
                          <div className="hub-pattern-cards" key={num}>
                            <div>
                              <img
                                src={`${IMG_URL}/d0/${icon}`}
                                alt={iconAlt || `Common role icon ${num}`}
                              />
                            </div>

                            <div
                              className="hub-pattern-cards-content"
                              dangerouslySetInnerHTML={{ __html: content }}
                            />
                          </div>
                        );
                    })}
                
              </div>

              <div className="hub-banner-bnts common-role-buttons">
                {SeoTemplate?.seo_common_explore_btn &&
                  SeoTemplate?.seo_common_explore_link && (
                    <a
                      href={`/${SeoTemplate?.seo_common_explore_link}`}
                      class="new-commom-btn homearche-explore"
                      style={{
                        "--blur_button_color":SeoTemplate.seo_common_explore_btn_color,
                        "--topic_banner_btn_2_color":
                          SeoTemplate.seo_common_explore_btn_color,
                        "--topic_banner_btn_2_color_hover":
                          SeoTemplate.seo_common_explore_btn_color_hover,
                        "--luminus_button_color_15": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 15%, white)`,
                        "--luminus_button_color_25": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 25%, white)`,
                        "--luminus_button_color_38": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 38%, white)`,
                        "--luminus_button_color_45": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 45%, white)`,
                        "--luminus_button_color_50": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 50%, white)`,
                        "--luminus_button_color_55": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 55%, white)`,
                        "--luminus_button_color_70": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 70%, white)`,
                        "--luminus_button_color_85": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 85%, white)`,
                        "--luminus_button_color_92": `color-mix(in srgb, ${SeoTemplate.seo_common_explore_btn_color} 92%, white)`,
                        "--luminus_button_color_100":
                          SeoTemplate.seo_common_explore_btn_color,
                      }}
                    >
                      <span>{SeoTemplate?.seo_common_explore_btn}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  )}

                {SeoTemplate?.seo_common_reveal_btn &&
                  SeoTemplate?.seo_common_reveal_link && (
                    <a
                      href={`/${SeoTemplate?.seo_common_reveal_link}`}
                      class="new-commom-btn hub-banner-reveal"
                      style={{
                        "--blur_button_color":SeoTemplate.seo_common_reveal_btn_color,
                        "--topic_banner_btn_2_color":
                          SeoTemplate.seo_common_reveal_btn_color,
                        "--topic_banner_btn_2_color_hover":
                          SeoTemplate.seo_common_reveal_btn_color_hover,
                        "--luminus_button_color_15": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 15%, white)`,
                        "--luminus_button_color_25": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 25%, white)`,
                        "--luminus_button_color_38": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 38%, white)`,
                        "--luminus_button_color_45": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 45%, white)`,
                        "--luminus_button_color_50": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 50%, white)`,
                        "--luminus_button_color_55": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 55%, white)`,
                        "--luminus_button_color_70": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 70%, white)`,
                        "--luminus_button_color_85": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 85%, white)`,
                        "--luminus_button_color_92": `color-mix(in srgb, ${SeoTemplate.seo_common_reveal_btn_color} 92%, white)`,
                        "--luminus_button_color_100":
                          SeoTemplate.seo_common_reveal_btn_color,
                      }}
                    >
                      <span>{SeoTemplate?.seo_common_reveal_btn}</span>

                      <span class="righ-arr">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </span>
                    </a>
                  )}
              </div>
            </div>
          </div>
        </section>

        <section className="seo-career">
          <div className="container">
            <div className="row hub-pattern-card-row ">
              <div className="hub-pattern-card-title">
                <div
                  dangerouslySetInnerHTML={{
                    __html: SeoTemplate?.seo_discover_title,
                  }}
                />
              </div>

              <div className="hub-pattern-card-outer hub-pattern-card-outer-poular best-role seo-row12">
                {discoverCards?.map((card, index) => (
                  <div className="hub-pattern-cards" key={index}>
                    <div>
                      <img
                        src={`${IMG_URL}/d0/${card.image}`}
                        alt={card?.alt}
                      />
                    </div>

                    <div className="hub-pattern-cards-content">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: card.content || "",
                        }}
                      />

                      {card.buttonLink && card.buttonLabel && (
                        <a
                          className="new-commom-btn hub-banner-reveal"
                          onClick={(e) => {
                            e.preventDefault();
                            setCareerContent(card.buttonLink);
                            setCarrerModal(true);
                          }}
                        >
                          <span>{card.buttonLabel}</span>

                          <span className="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="seo-discovery">
          <div className="container">

            <div className="seo-dic-cont">

              <div dangerouslySetInnerHTML={{__html:SeoTemplate?.job_content}}/>

              <div className="seo-dic-btn">
                <div className="hub-banner-bnts">
                  {SeoTemplate?.seo_explore_btn &&
                    SeoTemplate?.seo_explore_link && (
                      <a
                        href={`/${SeoTemplate?.seo_explore_link}`}
                        class="new-commom-btn homearche-explore"
                        style={{
                          "--blur_button_color":SeoTemplate.seo_explore_btn_color,
                          "--topic_banner_btn_2_color":
                            SeoTemplate.seo_explore_btn_color,
                          "--topic_banner_btn_2_color_hover":
                            SeoTemplate.seo_explore_btn_color_hover,
                          "--luminus_button_color_15": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 15%, white)`,
                          "--luminus_button_color_25": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 25%, white)`,
                          "--luminus_button_color_38": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 38%, white)`,
                          "--luminus_button_color_45": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 45%, white)`,
                          "--luminus_button_color_50": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 50%, white)`,
                          "--luminus_button_color_55": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 55%, white)`,
                          "--luminus_button_color_70": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 70%, white)`,
                          "--luminus_button_color_85": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 85%, white)`,
                          "--luminus_button_color_92": `color-mix(in srgb, ${SeoTemplate.seo_explore_btn_color} 92%, white)`,
                          "--luminus_button_color_100":
                            SeoTemplate.seo_explore_btn_color,
                        }}
                      >
                        <span>{SeoTemplate?.seo_explore_btn}</span>

                        <span class="righ-arr">
                          <FontAwesomeIcon icon={faArrowRight} />
                        </span>
                      </a>
                    )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="seo-faq">
          <div className="container">
            <div className="row hub-faq-question">
              <div className="hub-pattern-card-title faq-title-head">
                <div
                  dangerouslySetInnerHTML={{ __html: SeoTemplate?.faq_content }}
                />
              </div>

              <div className="col-12 col-sm-12 col-md-12">
                <div className="faq-container">
                  {faqData?.map((item, index) => (
                    <div
                      key={index}
                      className="faq-item"
                      onClick={() => toggle(index)}
                    >
                      <div className="faq-title">
                        <h3>{item.question}</h3>
                        <span className="arrow-icon">
                          <img
                            className={openIndex === index ? "rotate1" : ""}
                            src={arr}
                            alt=""
                          />
                        </span>
                      </div>
                      {openIndex === index && (
                        <div className="faq-content">
                          <p
                            dangerouslySetInnerHTML={{ __html: item?.answer }}
                          ></p>
                        </div>
                      )}
                      <hr />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {CarrerModal && (
        <div className="newdashpop-overlay lock-dashboard carrer-banner">
          <div className="newdashpop-inner">
            <div className="newdashpop-container">
              <button
                className="newdashpop-close"
                onClick={() => {
                  setCarrerModal(false);
                  setCareerContent("");
                }}
              >
                &times;
              </button>

              <div className="conent-pop lock-dashboard-content">
                <div className="dash-loc-title">
                  <div dangerouslySetInnerHTML={{ __html: careerContent }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SeoTemplate;
